import * as React from "react";

import { IProfile, LineID, ILineUpdate } from "src/api/APIClient";
import LinePickerContainer from "./LinePicker";
import { connect } from "react-redux";
import { updateLine as updateLineAction } from "src/thunks";

interface IProps {
  profiles: IProfile[];

  target: string | HTMLElement;
  isOpen: boolean;
  toggle?: () => any;

  updateLine: (update: ILineUpdate) => any;
}

export class ProfileLinePicker extends React.Component<IProps> {
  public render() {
    const { target, profiles, isOpen, toggle } = this.props;

    const lineCounts = profiles.reduce(
      (counts, profile) => {
        profile.lines.forEach(line => {
          counts[line] = counts[line] || 0;
          counts[line]++;
        });
        return counts;
      },
      {} as { [l: string]: number }
    );
    const checkedLines = Object.keys(lineCounts) as LineID[];
    const indeterminateLines = checkedLines.filter(
      line => lineCounts[line] !== profiles.length
    );

    return (
      <LinePickerContainer
        target={target}
        checked={checkedLines}
        indeterminate={indeterminateLines}
        allowCreate={true}
        isOpen={isOpen}
        autoFocus={true}
        onCreate={this.onCreate}
        onSelect={this.onSelect}
        toggle={toggle}
      />
    );
  }

  private onCreate = (id: LineID) => {
    const { profiles, toggle, updateLine } = this.props;

    const userIDs = profiles.map(p => p.id);

    updateLine({
      id,
      addUsers: userIDs,
    });

    if (toggle) {
      toggle();
    }
  };

  private onSelect = (id: LineID) => {
    const { profiles, updateLine, toggle } = this.props;

    const userIDs = profiles.map(p => p.id);
    const hasLine = !!profiles.find(p => p.lines.indexOf(id) >= 0);

    updateLine({
      id,
      addUsers: hasLine ? undefined : userIDs,
      removeUsers: hasLine ? userIDs : undefined,
    });

    if (toggle) {
      toggle();
    }
  };
}

export const ProfileLinePickerContainer = connect(
  () => ({}),
  dispatch => ({
    updateLine: (update: ILineUpdate) =>
      dispatch<any>(updateLineAction(update)),
  })
)(ProfileLinePicker);

export default ProfileLinePickerContainer;



// WEBPACK FOOTER //
// ./src/components/ProfileLinePicker.tsx